import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { IconButton as IconButton$1 } from '@mui/material';
import { theme } from '../../utils/themeProvider.js';
import { customArcherColors } from '../../utils/customArcherColors.js';
import '@mui/styles';
import '@mui/material/styles';
import 'uuid/v4';
import { hexToRGB } from '../../utils/hexToRGB.js';
import { Icon } from '../Icon/Icon.js';
var _excluded = ["icon", "label", "fontSize", "dataProp", "isActionIcon", "isExpansionPanelIcon", "actionType", "sx"];

var useStyles = function useStyles(stylingProps) {
  return {
    iconButtonRoot: {
      color: stylingProps.iconColor || 'primary.main',
      '&:hover': {
        borderRadius: '50%',
        backgroundColor: stylingProps.hoverColor
      },
      '&:focus': {
        backgroundColor: stylingProps.activeColor
      }
    }
  };
};

var IconButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var icon = props.icon,
      label = props.label,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
      _props$dataProp = props.dataProp,
      dataProp = _props$dataProp === void 0 ? "".concat(icon, "-button") : _props$dataProp,
      isActionIcon = props.isActionIcon,
      isExpansionPanelIcon = props.isExpansionPanelIcon,
      actionType = props.actionType,
      sx = props.sx,
      rest = _objectWithoutProperties(props, _excluded);

  var IconTrueColor = isActionIcon && customArcherColors.getCustomActionIconColors(actionType) || isExpansionPanelIcon && customArcherColors.getCustomExpansionPanelIconColors(actionType) || theme.palette.primary.main;
  var getActiveColor = IconTrueColor && hexToRGB(IconTrueColor, 0.15);
  var getHoverColor = IconTrueColor && hexToRGB(IconTrueColor, 0.07);
  var stylingProps = {
    iconColor: IconTrueColor,
    activeColor: getActiveColor,
    hoverColor: getHoverColor
  };

  var _useStyles = useStyles(stylingProps),
      iconButtonRoot = _useStyles.iconButtonRoot;

  var sxProps = [iconButtonRoot, sx];
  return /*#__PURE__*/React.createElement(IconButton$1, _extends({
    sx: sxProps,
    "aria-label": label
  }, rest, {
    ref: ref,
    "data-selector": dataProp
  }), icon && /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    fontSize: fontSize
  }));
});
IconButton.displayName = 'IconButton';
export { IconButton };